module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-2 py-0 kios-item"
  }, [(_vm.loading) ? _c('content-placeholders', {
    staticClass: "mt-3"
  }, [_c('content-placeholders-text', {
    attrs: {
      "lines": 10
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.detailActive) ? _c('h4', {
    staticClass: "pt-2 ml-2"
  }, [_c('span', {
    staticStyle: {
      "color": "#065694"
    }
  }, [_vm._v("CHỌN ĐƠN VỊ ")])]) : _vm._e(), _vm._v(" "), (_vm.detailActive) ? _c('div', {
    staticClass: "text-xs-center"
  }, [_c('h4', {
    staticClass: "py-2",
    staticStyle: {
      "color": "#065694"
    }
  }, [_vm._v("KHẢO SÁT MỨC ĐỘ HÀI LÒNG")]), _vm._v(" "), _c('h4', {
    staticClass: "pb-2",
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(_vm._s(_vm.govAgencyName(_vm.govAgencySelected)))])]) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.detailActive) ? _c('div', {
    staticClass: "mt-4",
    class: _vm.visible ? 'overlayActive' : ''
  }, [_c('v-layout', {
    staticClass: "wrap"
  }, _vm._l((_vm.govAgencyList), function(item, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "pr-3",
      attrs: {
        "xs6": "",
        "sm4": ""
      }
    }, [_c('v-btn', {
      staticClass: "kios-btn btn-select",
      staticStyle: {
        "width": "100%",
        "background-color": "#b3d4fc5c!important"
      },
      attrs: {
        "outline": "",
        "flat": "",
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.votingDetail(item)
        }
      }
    }, [_vm._v(_vm._s(item.administrationName))])], 1)
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.detailActive) ? _c('chi-tiet-danh-gia', {
    attrs: {
      "administration": _vm.govAgencySelected
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-2db7bcb9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2db7bcb9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DanhGiaChatLuongDichVu.vue
// module id = 526
// module chunks = 1